import { useLayoutEffect } from "react";
import { gsap } from "animations/gsap";
import { numberTicker, useGsapContext } from "animations";
import { Flip } from "gsap/Flip";
import styles from "./IntroBox.module.scss";

function useIntroBoxAnimations(
  el: any,
  target: Array<number>,
  targetTwo: Array<number> | undefined
) {
  const createTimeline = () => {
    gsap.set(".anim-wrapper", { yPercent: -50 });

    const text_tl = gsap.timeline({ paused: true });
    text_tl.current && text_tl.current.progress(0).kill();

    text_tl
      .fromTo(
        ".anim-primary",
        { yPercent: 100 },
        { yPercent: 0, opacity: 1, duration: 0.75, delay: 0.25 }
      )
      .fromTo(
        ".anim-secondary",
        { yPercent: -100 },
        { yPercent: 0, opacity: 1, duration: 0.75 },
        "<+=0.5"
      )
      .to(".anim-wrapper", { yPercent: 0, duration: 1 })
      .fromTo(
        ".anim-sub",
        { yPercent: -100 },
        { yPercent: 0, opacity: 1, duration: 0.75 },
        "<"
      );

    const introPercentTl = numberTicker({
      el: "anim-intro-box_percent",
      target: target,
    });
    introPercentTl?.current?.progress(0).kill();

    const introPercentTlTwo =
      targetTwo &&
      numberTicker({
        el: "anim-intro-box_percent_two",
        target: targetTwo,
      });
    introPercentTlTwo?.current?.progress(0).kill();

    const tlOnComplete = () => {
        Flip.fit(".anim-ticker-container", ".anim-placeholder", {
          duration: 1,
          ease: "power1.inOut",
          scale: true,
        });
        text_tl.play();
      },
      tl = gsap.timeline({
        paused: true,
        onComplete: tlOnComplete,
      });
    tl.current && tl.current.progress(0).kill();

    tl.to(".anim-ticker-container", { opacity: 1, duration: 0.75 }).add(
      introPercentTl.play()
    );

    if (introPercentTlTwo) {
      tl.fromTo(
        ".anim-dash",
        { opacity: 0 },
        { opacity: 1, duration: 0.75 },
        "<+=0.25"
      )
        .fromTo(
          "#anim-intro-box_percent_two",
          { opacity: 0 },
          { opacity: 1, duration: 0.75 },
          "<+=0.25"
        )
        .add(introPercentTlTwo.play(), "<+=0.25")
        .fromTo(
          ".anim-unit",
          { opacity: 0 },
          { opacity: 1, duration: 0.75 },
          "<+=0.25"
        );
    }
    return tl;
  };

  const ctx = useGsapContext(el);

  useLayoutEffect(() => {
    const resize_ob = new ResizeObserver(() => {
      ctx.revert();
      ctx.add(() => {
        createTimeline().play();
      });
    });
    resize_ob.observe(
      document.querySelector(`.${styles["intro-box"]}`) as HTMLDivElement
    );

    return () => {
      resize_ob.unobserve(
        document.querySelector(`.${styles["intro-box"]}`) as HTMLDivElement
      );
      ctx.revert();
    };
  }, []);
}
export default useIntroBoxAnimations;
